// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notificationsLogsMainDiv {
  width: 100%;
  height: 606px;
  padding: 32px;
  background: #fff;
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  margin-top: 28px;
}

.imgSize {
  height: 24px;
  width: 24px;
  margin-top: 2px;
}

.mainDivWebHooks {
  width: 100%;
  flex-shrink: 0;
}

.MuiFormControlLabel-root .MuiFormControlLabel-label {
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.headerstyle {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));

  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}

.DetailsStyle {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
}

.DetailsHeader {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));

  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 122.222% */
}
.labelStyle {
  font-family: Poppins;
  font-size: 12px;
  padding-top: 3px;
  font-weight: 500;
}

.descriptionStyle {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}

.singleDateStyle .MuiInputBase-root.MuiOutlinedInput-root {
  width: 180px !important;
  height: 28px;
}

pre {
  color: white;
}

.headerH1Bold {
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 128.571% */
  letter-spacing: -0.336px;
}

.dateComponenetStyle.MuiTypography-root {
  padding-top: 8px;
  color: rgba(1, 1, 2, 0.72);
}

.apiKeyHeading.MuiTypography-root {
  color: var(--Global-Neutral-Grey-1100, #2d2b32);
}

.apikeyModal .MuiPaper-root.MuiDialog-paper {
  width: 800px;
  max-width: 800px;
  border-radius: 16px;
}

.alertHeading.MuiTypography-root {
  color: var(--Global-Neutral-Grey-1300, #0a090b);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.02px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Developers/Notification Logs/webhooks.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;;EAE7C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,+CAA+C;;EAE/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;;EAE/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".notificationsLogsMainDiv {\n  width: 100%;\n  height: 606px;\n  padding: 32px;\n  background: #fff;\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  margin-top: 28px;\n}\n\n.imgSize {\n  height: 24px;\n  width: 24px;\n  margin-top: 2px;\n}\n\n.mainDivWebHooks {\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.MuiFormControlLabel-root .MuiFormControlLabel-label {\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.headerstyle {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n\n.DetailsStyle {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  font-family: Poppins;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.DetailsHeader {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n\n  font-family: Poppins;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 122.222% */\n}\n.labelStyle {\n  font-family: Poppins;\n  font-size: 12px;\n  padding-top: 3px;\n  font-weight: 500;\n}\n\n.descriptionStyle {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.singleDateStyle .MuiInputBase-root.MuiOutlinedInput-root {\n  width: 180px !important;\n  height: 28px;\n}\n\npre {\n  color: white;\n}\n\n.headerH1Bold {\n  font-family: Poppins;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 36px; /* 128.571% */\n  letter-spacing: -0.336px;\n}\n\n.dateComponenetStyle.MuiTypography-root {\n  padding-top: 8px;\n  color: rgba(1, 1, 2, 0.72);\n}\n\n.apiKeyHeading.MuiTypography-root {\n  color: var(--Global-Neutral-Grey-1100, #2d2b32);\n}\n\n.apikeyModal .MuiPaper-root.MuiDialog-paper {\n  width: 800px;\n  max-width: 800px;\n  border-radius: 16px;\n}\n\n.alertHeading.MuiTypography-root {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: -0.02px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
